export default __webpack_public_path__ + "assets/guam-flag.png";